import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Post } from "../../types/types"; // Импортируйте тип Post

// Асинхронное действие для извлечения поста по ID
export const fetchPostById = createAsyncThunk<Post, number>(
  "exactPost/fetchPostById",
  async (postId) => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    console.log("API_URL", API_URL);
    const response = await fetch(`${API_URL}/api/v1/posts/${postId}`);
    if (!response.ok) {
      throw new Error("Failed to fetch post");
    }
    const post: Post = await response.json();
    return post;
  }
);

// Начальное состояние
const initialState = {
  post: null,
  status: "idle", // idle | loading | succeeded | failed
  error: null,
};

// Создание среза
const exactPostSlice = createSlice({
  name: "exactPost",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPostById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPostById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.post = action.payload; // Сохраняем полученный пост
      })
      .addCase(fetchPostById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default exactPostSlice.reducer;
